module.exports = __webpack_public_path__ + "static/hackBU-d696536712a1838ca836bac9abebccf3.jpg";